module.exports = require('./dist/mgr-pdf-viewer-react');